'use client';
import styled from 'styled-components';
import { colors, mixins } from '@/styles';

export const Modal = styled.div<{}>`
  display: flex;
  flex-direction: column;
  background: ${colors.primary.white};
  padding: 50px;
  max-width: 75vw;
  min-width: 350px;
  gap: 25px;
  z-index: 1000;

  h4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  button {
    outline: none;
  }

  ${mixins.animatedGradientBorder({ borderRadius: 8, borderWidth: 3, glow: { size: '2rem', opacity: 0.5 } })};
`;

export const ModalClose = styled.div<{}>`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  &:hover {
    stroke-width: 2px;
  }
`;

export const ModalImage = styled.div<{}>`
  border-radius: 100%;
  overflow: hidden;
  width: 150px;
  height: 150px;

  img {
    width: 100%;
    object-fit: cover;
  }
`;
